/**
 * Admin-scoped DTOs for /api/app/bookseller-entitlement-configs.
 * Mirrors backend BooksellerEntitlementConfigDto / CreateDto / UpdateDto.
 */

export enum EntitlementAdapterType {
  Configurable = 1,
  CustomCode = 2,
  GraphQL = 3,
  SOAP = 4,
}

export const ENTITLEMENT_ADAPTER_TYPE_LABELS: Record<EntitlementAdapterType, string> = {
  [EntitlementAdapterType.Configurable]: 'Configurable (JSONPath REST)',
  [EntitlementAdapterType.CustomCode]: 'Custom Code (coming soon)',
  [EntitlementAdapterType.GraphQL]: 'GraphQL (coming soon)',
  [EntitlementAdapterType.SOAP]: 'SOAP (coming soon)',
};

export enum ApiAuthType {
  None = 1,
  Bearer = 2,
  ApiKey = 3,
  ClientCredentials = 4,
  BasicAuth = 5,
}

export const API_AUTH_TYPE_LABELS: Record<ApiAuthType, string> = {
  [ApiAuthType.None]: 'None',
  [ApiAuthType.Bearer]: 'Bearer Token',
  [ApiAuthType.ApiKey]: 'API Key',
  [ApiAuthType.ClientCredentials]: 'OAuth Client Credentials',
  [ApiAuthType.BasicAuth]: 'Basic Auth',
};

export interface BooksellerEntitlementConfigAdminDto {
  id: string;
  booksellerId: string;
  adapterType: EntitlementAdapterType;
  endpoint: string;
  httpMethod: string;
  authType: ApiAuthType;
  apiKey?: string | null;
  apiKeyHeaderName?: string | null;
  requestMapping?: string | null;
  responseMapping?: string | null;
  retryPolicy?: string | null;
  timeoutSeconds: number;
  cacheDurationMinutes: number;
  oAuthTokenEndpoint?: string | null;
  oAuthClientId?: string | null;
  oAuthClientSecret?: string | null;
  oAuthScopes?: string | null;
  concurrencyStamp: string;
  creationTime: string;
  lastModificationTime?: string | null;
  isDeleted: boolean;
}

export interface CreateBooksellerEntitlementConfigDto {
  booksellerId: string;
  adapterType: EntitlementAdapterType;
  endpoint: string;
  httpMethod: string;
  authType: ApiAuthType;
  apiKey?: string;
  apiKeyHeaderName?: string;
  requestMapping?: string;
  responseMapping?: string;
  retryPolicy?: string;
  timeoutSeconds: number;
  cacheDurationMinutes: number;
  oAuthTokenEndpoint?: string;
  oAuthClientId?: string;
  oAuthClientSecret?: string;
  oAuthScopes?: string;
}

export interface UpdateBooksellerEntitlementConfigDto {
  booksellerId: string;
  adapterType: EntitlementAdapterType;
  endpoint: string;
  httpMethod: string;
  authType: ApiAuthType;
  /** Same null/empty/value contract as UpdateBooksellerAuthConfigDto.clientSecret. */
  apiKey?: string;
  apiKeyHeaderName?: string;
  requestMapping?: string;
  responseMapping?: string;
  retryPolicy?: string;
  timeoutSeconds: number;
  cacheDurationMinutes: number;
  oAuthTokenEndpoint?: string;
  oAuthClientId?: string;
  /** Same null/empty/value contract as apiKey. */
  oAuthClientSecret?: string;
  oAuthScopes?: string;
  concurrencyStamp: string;
}
